import staticQueryData from "../../public/static/d/856328897.json";

/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from "react";
import PropTypes from "prop-types";
import Header from "./header";
import "../assets/sass/style.scss";

var Layout = function Layout(_ref) {
  var children = _ref.children;
  var data = staticQueryData.data;
  return React.createElement(React.Fragment, null, React.createElement(Header, {
    siteTitle: data.site.siteMetadata.title
  }), React.createElement("div", null, React.createElement("main", null, children), React.createElement("footer", null, "\xA9 ", new Date().getFullYear(), ",", " ", React.createElement("a", {
    href: "https://www.aranhaagency.github.io"
  }, "ARANHA LLC."))));
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};
export default Layout;